export default __webpack_public_path__ + "static/media/agency.cff45bfc.svg";